// Root-relative API paths get the API base (nginx routes only /api/); an /api route reads /api/api by design.
export const resolveImageSrc = (
  src: string | undefined | null,
  apiUrl: string = import.meta.env.VITE_API_URL || '',
): string => {
  if (!src) return '';
  if (src.startsWith('data:') || src.startsWith('http')) return src;
  if (apiUrl && src.startsWith(apiUrl)) return src;
  if (src.startsWith('/')) return `${apiUrl}${src}`;
  return src;
};
